//src/app/features/payments/redicrectionPages/paymentFailed/index.tsx
import { WarningIcon } from 'assets/icons';
import { CustomButton } from 'Components/Auth/CustomButton';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PaymentFailed() {
  const navigate = useNavigate();

  return (
    <div className="  text-align-webkit-center mt-16 ">
      <WarningIcon className=" h-20 w-20" />
      <p className=" py-10 font-extrabold  text-medium "> Payment Error </p>
      <div className="w-1/2 inline-flex gap-4">
        <CustomButton
          text="Change Payment Method"
          onClick={() => navigate(`/dashboard/services/add-service`)}
          bgColor="white"
          borderColor="gray-dark"
          textColor="gray-dark"
        />
        <CustomButton
          text="Try Again"
          onClick={() => navigate(`/dashboard/payments`)}
        />
      </div>
    </div>
  );
}
